<template>
    <div>
        <b-row>
                <b-col cols="10">
                    <h4 v-if="checkFlag">Please enter question text for Read-Aloud.</h4>
                    <h4 v-else>Please select excel sheet for bulk question saving</h4>
                </b-col>
                <b-col cols="2">
                    <toggle-button :width="75" :height="28" v-model="checkFlag" :value="false" :color="{checked: '#104e94', unchecked: '#e9ecef', disabled: '#CCCCCC'}" :speed="500" :sync="true" :labels="{checked: 'enter', unchecked: 'load'}"/>
                </b-col>
            <b-form  v-if="checkFlag" class="col-12"  @submit="onSubmit" @reset="onReset">
            
            <b-row>
                <b-col cols="6">
                    <label for="title">Enter Title</label>
                    <b-form-input v-model="readaloud.title" placeholder="Enter Question Title"></b-form-input>
                </b-col>
                <b-col cols="6">
                    <label for="mock_ind">Select Question Type</label>
                    <b-form-select v-model="readaloud.mock_ind" :options="options"></b-form-select>
                </b-col>
            </b-row>
            <b-col cols="12">
                <div class="form-group">
                    <label for="textarea">Enter Question Text</label>
                    <textarea v-model="readaloud.readaloud_text" class="form-control" id="textarea" rows="10"></textarea>
                </div>
            </b-col>
            <div class="col-6 displayInline" align="right">
                <b-button type="submit" variant="primary" :disabled="allFilled != true">{{buttonText}}</b-button>
            </div>
            <div class="col-6 displayInline" align="left">
                <b-button type="reset" variant="outline-danger">Reset</b-button>
            </div>
            </b-form>
        </b-row>
        <b-row v-if="checkFlag" class="mt-4 ml-2 mr-2">
            <b-col cols="12">
                <b-alert
                :show="dismissCountDown"
                dismissible
                variant="outline-success"
                @dismissed="dismissCountDown=0"
                
                >
                Record saved successfully, dismiss in {{ dismissCountDown }} seconds...
                </b-alert>
            </b-col>
        </b-row>
        <b-row v-if="checkFlag" class="mt-4 ml-2 mr-2">
            <b-col cols="12">
                <b-table
                    id="readaloud"
                    :items="allQuestions"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :fields="fields"
                    sort-icon-left
                    small
                    outlined
                    responsive
                    >
                    <template #cell(readaloud_id)="data">
                    <!-- `data.value` is the value after formatted by the Formatter -->
                    <b-button variant="outline-warning" @click="deleteRecord(data.value)">
                        <b-icon icon="trash-fill"></b-icon>
                    </b-button>
                    <!-- <a href="#">{{data.value}}</a> -->
                </template>
                <template #cell(readaloud_text)="data">
                    <!-- `data.value` is the value after formatted by the Formatter -->
                    <read-more class="readmoreDiv" more-str="read more" :text="data.value" link="#" less-str="read less" :max-chars="100"></read-more>
                    <!-- <p class="transcript">{{data.value}}</p> -->
                </template>
                </b-table>
            </b-col>
            <b-col cols="12">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="readaloud"
                    ></b-pagination>
            </b-col>
        </b-row>
         <div v-if="!checkFlag" class="row mt-4 ml-2 mr-2">
            <div class="col-12">
                
                <div class="form-group">
                    <label for="excelFile">Select Excel file</label>
                    <b-form-file
                        id="excelFile"
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."
                        accept=".xlsx"
                        @change="onFileChange"></b-form-file>
                </div>
            </div>
            <div class="col-12 text-center">
                <b-button :disabled="!fileLoad" @click="readFile()" class="mr-4">Read File</b-button>
                <b-button :disabled="!readFileFlag" variant="primary" @click="saveRecordExcel(1)">{{saveRecord}}</b-button>
            </div>
        </div>
        <div v-if="!checkFlag" class="row mt-4 ml-2 mr-2">
            <div class="col-12">
            <ul id="console-textarea" >
                <li v-for="(item,index) in consoleLog" :key="index">
                    {{item}}
                </li>
            </ul>
            </div>
        </div>

        
       
    </div>
</template>

<script>
import { mapActions,mapGetters } from 'vuex'
import readXlsxFile from 'read-excel-file'
export default {
    data(){
        return{
            buttonText:'Save',
            allFilled: false,
            dismissSecs: 5,
            dismissCountDown: 0,
            excelFile:null,
            fileLoad:false,
            checkFlag:true,
            readFileFlag:false,
            rowsLoadedArray:null,
            saveRecord:'Save Record',
            consoleLog:['Log Info.'],
            readaloud:{
                title:'',
                readaloud_text:'',
                reading_slot_time:'00:10',
                speaking_slot_time:'00:40',
                mock_ind:'0',
                url:''
            },
            userAnswerResponse: null,
            allQuestions:null,
            perPage: 8,
            currentPage: 1,
            fields: [
            {
                key: 'readaloud_id',
                label:'Delete',
                sortable: false
            },
            // {
            //     key: 'readaloud_id',
            //     label:'ID',
            //     sortable: true
            // },
            {
                key: 'title',
                label:'Title',
                sortable: false
            },
            {
                key: 'readaloud_text',
                label:'Transcript',
                sortable: false
            }
            ],
            options: [
            { value: '0', text: 'Please select an option' },
            { value: 'F', text: 'General' },
            { value: 'T', text: 'Mock Test' }
            ]
        }
    },
    methods:{
        ...mapActions({
            saveAnswer: 'speakmodule/saveAnswer',
            saveQuestion:'speakmodule/saveQuestion',
            questionservice: 'speakmodule/fetchQuestion',
            deleteQuestion:'speakmodule/deleteQuestion',

        }),
        ...mapGetters({
            answerResponse: 'speakmodule/AnswerResponse',
            getQuestionList: 'speakmodule/questions',
            QuestionResponse: 'auth/UPDATEQuestionStatus',
        }),
        onFileChange(e) {
            const file = e.target.files[0];
            this.excelFile=file
            this.fileLoad =true
            this.readFileFlag=false
            this.consoleLog.push('Selected file loaded.')
            // this.loadedFile = e.target.files
            // this.fileUrl = URL.createObjectURL(file);
        },
        readFile(){
            if(this.excelFile!=null){
            readXlsxFile(this.excelFile).then((rows) => {
                            //console.log(rows)
                            this.consoleLog.push('Total records retrieve from excel sheet ' +rows.length +'.')
                            this.fileLoad =false
                            this.readFileFlag=true
                            this.rowsLoadedArray=rows
                        })
            }
        },
        saveRecordExcel(index){
            if(this.rowsLoadedArray==null)
            {
                return this.$alert('No record found')
            }
            else{
                let today = new Date().toLocaleDateString()
                var item=this.rowsLoadedArray[index]
                this.readaloud={
                    readaloud_id:0,
                    title:item[1],
                    readaloud_text:item[2],
                    new_ind:item[3],
                    predicted_ind:(item[4])?'Y':'N',
                    exam_ind:(item[5])?'Y':'N',
                    reading_slot_time:today,
                    speaking_slot_time:'00:40',
                    mock_ind:'F',
                    url:''
                }
                var findRecord=this.allQuestions.filter((item)=>{
                    return item.title.trim().toLowerCase()==this.readaloud.title.trim().toLowerCase()
                })[0]
                if(findRecord!=null){
                    this.readaloud.url='configreadaloud/UpdateBulkReadAloud'
                    this.readaloud.readaloud_id=findRecord.readaloud_id
                }
                else {
                    this.readaloud.url='configreadaloud/InsertBulkReadAloud'
                }
                this.saveQuestion(this.readaloud).then(()=>{
                        var res = this.answerResponse()
                        var id=0
                        var dte=new Date().toISOString().slice(0, 19).replace('T', ' ');
                        if(findRecord!=null){
                            id=findRecord.readaloud_id
                        }
                        else{
                            id=res.data.insertId
                        }
                        this.consoleLog.push(res.message)
                        const param={
                            tableName:'tblReadAloud',
                            idName:'readaloud_id', 
                            id:id,
                            predicted_ind:this.readaloud.predicted_ind,
                            predicted_date:dte,
                            exam_ind:this.readaloud.exam_ind,
                            title:this.readaloud.title,
                            exam_date:dte,
                            type:'single',
                            url:'updatequestion/status',
                        }
                        //console.log(param)
                        this.saveQuestion(param).then(()=>{
                            var resStatus = this.answerResponse()
                            this.consoleLog.push(resStatus.message)
                            if(index<this.rowsLoadedArray.length-1){
                            this.saveRecordExcel(index+1)
                            }
                        })
                        
                         
                    });
                
            }
        },
        onReset(evt) {
            evt.preventDefault()
            this.resetFrom()
        },
        resetFrom(){
            this.readaloud={
                title:'',
                readaloud_text:'',
                reading_slot_time:'00:10',
                speaking_slot_time:'00:40',
                mock_ind:'0',
                url:'configreadaloud/createreadaloud'
            }
        },
        onSubmit(evt) {
            evt.preventDefault()
            //////console.log(JSON.stringify(this.readaloud))
            ////console.log(this.readaloud)
            let formData = new FormData();
            formData.append('data', JSON.stringify(this.readaloud));
            this.readaloud.url = 'configreadaloud/createreadaloud'
            var vm = this
            if(!this.matchString(this.readaloud.readaloud_text, this.readaloud.title)) 
                return vm.$alert(
                            "Similar question is already saved!",
                            "Warning",
                            "warning",
                            {
                                confirmButtonText: "OK"
                            })
                //alert('Similar question is already saved!');

            this.saveQuestion(this.readaloud).then(()=>{
                ////console.log(this.answerResponse())
                vm.userAnswerResponse = this.answerResponse().data
                vm.readaloud.readaloud_id = vm.userAnswerResponse.insertId
                ////console.log(vm.readaloud)
                vm.allQuestions.push( vm.readaloud)
                vm.$parent.getQuestionTypes();
                vm.resetFrom();
                 vm.dismissCountDown = vm.dismissSecs
                //////console.log(this.userAnswerResponse.message)
            });
        },
        deleteRecord(id){
            var data={
                url:'configreadaloud/deletereadaloud/id='+id
            }
            var vm = this
             this.deleteQuestion(data).then(()=>{
                vm.allQuestions = this.allQuestions.filter(function (item) {
                return item.readaloud_id != id;
                })
                ////console.log(vm.allQuestions)
                vm.$parent.getQuestionTypes();
            });
            ////console.log(id)
        },
        matchString(transcript,title){
            var existQuestion = this.allQuestions.filter(function (item) {
                return item.readaloud_text.toLowerCase().trim() === transcript.toLowerCase().trim() | 
                item.title.toLowerCase().trim() === title.toLowerCase().trim();
                })[0];
            return (existQuestion !=null | existQuestion != undefined)?  false: true;
        }
    },
    watch:{
        readaloud: {
            deep: true,
            handler () {
                this.allFilled = false
                if(this.readaloud.title !== '' & this.readaloud.question !== '' 
                    & this.readaloud.reading_slot_time !=='' & this.readaloud.speaking_slot_time !=='')
                {
                    this.allFilled = true
                }
            }
        }
    },
    computed: {
      rows() {
          if(this.allQuestions == null){
              return 0
          }
          else{
              return this.allQuestions.length
          }
      }
    },
    beforeMount(){
        this.allQuestions = null
        this.questionservice('configreadaloud/getAllReadAloudForGrid').then(()=>{
            this.allQuestions = this.getQuestionList().data
            ////console.log(this.allQuestions)
        })
    },
}
</script>

<style scoped>
textarea {
    height: 40vh;
    width: 100%;
    border: 1px solid #ccc;
    resize: none;
}
label
{
margin-top: 10px;
text-transform: capitalize;
font-weight: 500;
}
.vue-js-switch{
    margin-top: 0px!important;
}
</style>